import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import { ProcedureTwoService } from '../../services/procedures/procedure-two.service';
import {FilesService} from "../../services/files.service";

@Component({
  selector: 'ngx-procedure-ten',
  templateUrl: './procedure-ten.component.html',
  styleUrls: ['./procedure-ten.component.scss'],
})
export class ProcedureTenComponent implements OnInit {
  @Input() stationId;
  state = 'Actividades';
  documents = {
    matriz: '',
    controlMonitoreo: '',
  };
  downloading = false;
  constructor(
    private procedureService: ProcedureTwoService,
    private fileService: FilesService,
  ) { }

  async ngOnInit() {
    await this.generateDocument();
  }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  async generateDocument() {
    this.documents.controlMonitoreo = `${environment.baseEndpoint}/filesGeneratorv2/implementation/two/environmental/impacts/two/${this.stationId}`;
    this.documents.matriz = `${environment.baseEndpoint}/filesGeneratorv2/implementation/two/environmental/impacts/one/${this.stationId}`;
  }

  async downloadFile(url) {
    this.downloading = true;
    await this.fileService.downloadFile(url);
    this.downloading = false;
  }

}
